var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 8.00065C1.3335 4.33398 4.3335 1.33398 8.00016 1.33398C11.6668 1.33398 14.6668 4.33398 14.6668 8.00065C14.6668 11.6673 11.6668 14.6673 8.00016 14.6673C4.3335 14.6673 1.3335 11.6673 1.3335 8.00065ZM10.8002 5.20065C11.0668 5.46732 11.0668 5.86732 10.8002 6.13398L8.9335 8.00065L10.8002 9.86732C11.0668 10.134 11.0668 10.534 10.8002 10.8007C10.5335 11.0673 10.1335 11.0673 9.86683 10.8007L8.00016 8.93398L6.1335 10.8007C5.86683 11.0673 5.46683 11.0673 5.20016 10.8007C4.9335 10.534 4.9335 10.134 5.20016 9.86732L7.06683 8.00065L5.20016 6.13398C4.9335 5.86732 4.9335 5.46732 5.20016 5.20065C5.46683 4.93398 5.86683 4.93398 6.1335 5.20065L8.00016 7.06732L9.86683 5.20065C10.1335 4.93398 10.5335 4.93398 10.8002 5.20065Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.af7fdc0f4fc21cfc8f094e8620cca4a6.svg";
export { ForwardRef as ReactComponent };